import React from 'react';
import { ShieldCheck, Users, Lock } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-navy-900 text-white overflow-hidden pt-16 pb-24 lg:pt-24 lg:pb-32" data-id="element-67">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-68">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-69">
          {/* Text Content */}
          <div className="max-w-2xl" data-id="element-70">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-navy-800 border border-navy-700 text-gold-400 text-sm font-semibold mb-6" data-id="element-71">
              <span className="relative flex h-2 w-2" data-id="element-72">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold-400 opacity-75" data-id="element-73"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-gold-500" data-id="element-74"></span>
              </span>
              Sistema #1 para Latinos en EE.UU.
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-tight" data-id="element-75">
              Toma el Control de tu Crédito y Construye tu{' '}
              <span className="text-gold-500" data-id="element-76">Sueño Americano</span>
            </h1>

            <p className="text-lg sm:text-xl text-slate-300 mb-8 leading-relaxed" data-id="element-77">
              El programa paso a paso diseñado específicamente para que la
              comunidad latina repare su crédito, elimine deudas negativas y
              acceda a las mejores oportunidades financieras en Estados Unidos.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10" data-id="element-78">
              <a href="#pricing" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-md text-navy-900 bg-gold-500 hover:bg-gold-400 transition-colors shadow-lg w-full sm:w-auto text-center" data-id="element-79">
                Quiero Aprender Sobre Crédito
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-6 text-sm font-medium text-slate-400" data-id="element-80">
              <div className="flex items-center gap-2" data-id="element-81">
                <ShieldCheck className="w-5 h-5 text-gold-500" data-id="element-82" />
                <span data-id="element-83">Garantía 30 días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-84">
                <Users className="w-5 h-5 text-gold-500" data-id="element-85" />
                <span data-id="element-86">+10,000 Latinos</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-87">
                <Lock className="w-5 h-5 text-gold-500" data-id="element-88" />
                <span data-id="element-89">Pago 100% Seguro</span>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative hidden lg:block" data-id="element-90">
            <div className="absolute inset-0 bg-gold-500 rounded-2xl transform translate-x-4 translate-y-4 opacity-20" data-id="element-91"></div>
            <img src="https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&q=80&w=800" alt="Familia latina revisando finanzas" className="relative rounded-2xl shadow-2xl object-cover h-[600px] w-full border border-navy-700" data-id="element-92" />

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl border border-slate-100 flex items-center gap-4" data-id="element-93">
              <div className="bg-green-100 p-3 rounded-full" data-id="element-94">
                <svg className="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-95">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" data-id="element-96" />
                </svg>
              </div>
              <div data-id="element-97">
                <p className="text-sm text-slate-500 font-medium" data-id="element-98">
                  Puntaje Promedio
                </p>
                <p className="text-xl font-bold text-navy-900" data-id="element-99">+120 Puntos</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}